import axios from 'axios';

export default async function createGoogleLocation(
  accessToken,
  userId,
  locationData,
) {
  const requestOptions = {
    headers: {
      'access-token': accessToken,
    },
  };

  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_GOOGLE_API_URL}/${userId}`,
      locationData,
      requestOptions,
    );

    return data;
  } catch (err) {
    return err.response;
  }
}
